import React, { useEffect, useState, useMemo, useCallback } from 'react';
import {
    TextField, FormControl, InputLabel, Grid, Paper, Select, MenuItem,
    useMediaQuery, Button, FormHelperText, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Checkbox, Autocomplete
} from '@mui/material';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import Titlebar from '../TitleBar';
import { SaleOrderList } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import { useDispatch, useSelector } from 'react-redux';
import { getCurrentDate } from '../../Utils/Dateutils';
import { selectFirm, selectQTEntryNo, selectSalebarcd, selectsono, selectSOwiseParty } from '../Selectors/Master/ItemSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { fetchSaleBarcode, fetchSOno, getPartyList, getQuotationEntryNo, insertSOquotwise } from '../../Store/PHPSlice/Sale/SaleOrder';
import CircularProgress from '@mui/material/CircularProgress';

const baseUrl = process.env.REACT_APP_BASE_URL;


const SOqtwise = () => {
    const userdata = JSON.parse(localStorage.getItem('user'));
    const [formData, setFormData] = useState({
        sono: '',
        quotNo: ' ',
        ordt: getCurrentDate(),
        firm: ' ',
        party: ' ',
        totqty: '0',
        itemNm: '',
        mclothNm: '',
        m1clothNm: '',
        m2clothNm: '',
        m3clothNm: '',
        qty: [],
        quotvalue: '',
        qItemNo: '',
        entry_type: '0',
        orgbarcode: '',
        barcode: '',
        orderNo: '',
        userId: userdata?.ID
    });
    const [itemData, setItemData] = useState({
        data: [],
        avgs: []
    });
    const [qtyIndex, setQtyIndex] = useState([]);
    const [openTable, setOpenTable] = useState(false);
    const [entries, setEntries] = useState([]);
    const [selectedRows, setSelectedRows] = useState(new Set());

    const [loading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const firmlist = useSelector(selectFirm);
    const partylist = useSelector(selectSOwiseParty);
    const quotlist = useSelector(selectQTEntryNo);
    const sono = useSelector(selectsono);
    const barcode = useSelector(selectSalebarcd);
    useEffect(() => {
        dispatch(fetchCompanyData());
        dispatch(fetchSOno());
        dispatch(fetchSaleBarcode());
    }, [dispatch]);

    useEffect(() => {
        if (sono) {
            const item = sono.data.SOno || '';
            setFormData(prevFormData => ({
                ...prevFormData,
                sono: item
            }));
        }
    }, [sono]);
    useEffect(() => {
        if (formData.firm) {
            dispatch(getPartyList(formData.firm))
        }
    }, [formData.firm, dispatch]);

    useEffect(() => {
        if (formData.firm && formData.party) {
            const post = {
                firmId: formData.firm,
                partyId: formData.party
            };
            dispatch(getQuotationEntryNo(post));
        }
    }, [formData.firm, formData.party, dispatch]);

    useEffect(() => {
        if (barcode?.data) {
            const bar = barcode?.data?.sobar;
            setFormData(prevFormData => ({
                ...prevFormData,
                barcode: prevFormData.barcode || bar,
                orgbarcode: bar
            }));
        }
    }, [barcode]);

    const isDesktop = useMediaQuery('(min-width:768px)');

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [dropdownType]: value
        }));

        if (dropdownType === 'quotNo' && value) {
            const id = parseInt(value);
            fetchGetData(id); // Fetch data when a quotation is selected
            setOpenTable(true);
        }
    };

    const fetchGetData = async (id) => {
        try {
            const response = await fetch(`${baseUrl}?apicall=getQuotationViewlist&quotId=${id}`);

            // Check if the response is OK (status code 200)
            if (!response.ok) {
                throw new Error('Network response was not ok');
            }

            // Parse the response as JSON
            const data = await response.json();

            // Assuming the response has `data` and `avgs` arrays, as shown in your example
            const filteredData = data.avgs.map(item => ({
                size: item.size,
                mavg: item.mavg,
                rate: item.rate,
                mrp: item.mrp,
                m1avg: item.m1avg,
                m2avg: item.m2avg,
                m3avg: item.m3avg,
            }));

            // Now you can use filteredData for further processing or display in the table
            setItemData({ data: data.data, avgs: filteredData });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const handleAddClick = () => {
        // Add the current form data to the entries array
        const newEntries = convertIntoOneObject(itemData, formData);
        setEntries(prevEntries => [...prevEntries, newEntries]);
        // Reset the form data to the initial state
        const newTotqty = entries.reduce((sum, item) => sum + item.totqty, 0) + newEntries.totqty;

        setFormData(prev => ({
            ...prev,
            quotNo: ' ',
            qty: [],
            totqty: newTotqty,
            barcode: parseInt(prev.barcode, 10) + 1
        }));
        setOpenTable(false);
        // toast.success('Data added successfully');
    };

    // console.log(qtyIndex);
    function convertIntoOneObject(itemData, formData) {
        const totarr = qtyIndex?.map(item => formData.qty[item]);
        const sumqty = totarr?.reduce((sum, qty) => sum + parseInt(qty) || 0, 0);
        if (itemData.data.length > 0) {
            var quotno = itemData.data[0].quotNo || '';
            var qItemNo = itemData.data[0].qItemNo || '';
            var itemNm = itemData.data[0].itemNm || '';
            var mclothNm = itemData.data[0].clothNm || '';
            var m1clothNm = itemData.data[0].m1cloth || '';
            var m2clothNm = itemData.data[0].m2cloth || '';
            var m3clothNm = itemData.data[0].m3cloth || '';
            var itemId = itemData.data[0].itemId || '';
            var schlId = itemData.data[0].schoolId || '';
            var mainId = itemData.data[0].clothId || '';
            var m1Id = itemData.data[0].m1 || '';
            var m2Id = itemData.data[0].m2 || '';
            var m3Id = itemData.data[0].m3 || '';
        }

        const sizearr = itemData.avgs.map(item => item.size);
        const ratearr = itemData.avgs.map(item => item.rate);
        const mavgarr = itemData.avgs.map(item => item.mavg);
        const m1avgarr = itemData.avgs.map(item => item.m1avg);
        const m2avgarr = itemData.avgs.map(item => item.m2avg);
        const m3avgarr = itemData.avgs.map(item => item.m3avg);

        return {
            size: qtyIndex?.map(item => sizearr[item]),
            rate: qtyIndex?.map(item => ratearr[item]),
            mavg: qtyIndex?.map(item => mavgarr[item]),
            m1avg: qtyIndex?.map(item => m1avgarr[item]),
            m2avg: qtyIndex?.map(item => m2avgarr[item]),
            m3avg: qtyIndex?.map(item => m3avgarr[item]),
            quotationNo: `${quotno}-${itemNm}`,
            particular: `${formData.barcode} - ${itemNm} ${mclothNm} ${m1clothNm !== '0' ? m1clothNm : ''} ${m2clothNm !== '0' ? m2clothNm : ''} ${m3clothNm !== '0' ? m3clothNm : ''}`,
            qty: qtyIndex?.map(item => formData.qty[item]),
            totqty: sumqty,
            quotId: formData.quotNo,
            itemId: itemId,
            schoolId: schlId,
            clothId: mainId,
            m1Id: m1Id,
            m2Id: m2Id,
            m3Id: m3Id,
            barcode: formData.barcode,
            itemNm: itemNm,
            mclothNm: mclothNm,
            m1clothNm: m1clothNm,
            m2clothNm: m2clothNm,
            m3clothNm: m3clothNm
        };
    };

    function finalObject(entries, formData) {
        const final = {
            sono: formData.sono,
            orderNo: formData.orderNo,
            ordt: formData.ordt,
            totqty: formData.totqty,
            firm: formData.firm,
            party: formData.party,
            entry_type: formData.entry_type,
            userId: formData.userId,
            entries: entries
        }
        return final;
    }
    const handleQtyChange = (index, value) => {
        setQtyIndex(prev => {
            // Add the index only if it is not already present
            if (!prev.includes(index)) {
                return [...prev, index];
            }
            return prev;
        });
        setFormData(prevFormData => {
            const newQty = [...prevFormData.qty];
            newQty[index] = value;
            return { ...prevFormData, qty: newQty };
        });
    };

    const handleCheckboxChange = (index) => {
        setSelectedRows(prevSelectedRows => {
            const newSelectedRows = new Set(prevSelectedRows);
            if (newSelectedRows.has(index)) {
                newSelectedRows.delete(index);
            } else {
                newSelectedRows.add(index);
            }
            return newSelectedRows;
        });
    };

    const handleRemoveClick = () => {
        setEntries(prevEntries => {
            // Step 1: Filter entries to keep (i.e., not selected)
            const remainingEntries = prevEntries.filter((_, index) => !selectedRows.has(index));
            // Log the data of the selected rows
            const selectedData = prevEntries.filter((_, index) => selectedRows.has(index));
            // console.log("Selected rows data:", selectedData);

            // Calculate the total quantity from the selected rows
            const totalQtyToRemove = selectedData.reduce((acc, item) => acc + parseInt(item.totqty, 10), 0);

            const baseBarcode = parseInt(formData.orgbarcode, 10); // You can change this to match your logic
            const updatedEntries = remainingEntries.map((item, i) => ({
                ...item,
                barcode: `${baseBarcode + i}`, // e.g., '10001', '10002', etc.
                particular: `${baseBarcode + i} - ${item.itemNm} ${item.mclothNm} ${item.m1clothNm !== '0' ? item.m1clothNm : ''} ${item.m2clothNm !== '0' ? item.m2clothNm : ''} ${item.m3clothNm !== '0' ? item.m3clothNm : ''}`,
            }));

            // Set the last barcode value
            const latestBar = updatedEntries.length > 0 ? `${baseBarcode + updatedEntries.length}` : formData.orgbarcode;

            // Update the formdata.totqty by subtracting the totalQtyToRemove
            setFormData(prevFormData => ({
                ...prevFormData,
                totqty: parseInt(prevFormData.totqty, 10) - totalQtyToRemove || '0',
                barcode: latestBar
            }));
            // console.log(updatedEntries);
            // Filter out the selected rows
            return updatedEntries;
        });

        setSelectedRows(new Set()); // Clear the selected rows
    };

    const handleDateChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({ ...prevFormData, [name]: value }));
    };
    const tableContainerStyle = {
        marginTop: '1%',
        overflow: 'hidden',
        scrollbarWidth: 'none',
        msOverflowStyle: 'none',
    };

    const webkitScrollbarStyle = {
        overflowX: 'auto',
        overflowY: 'hidden',
        WebkitOverflowScrolling: 'touch',
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevFormData => ({ ...prevFormData, [name]: value.toUpperCase() }));
    };


    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const finalObj = finalObject(entries, formData);

            const result = await dispatch(insertSOquotwise(finalObj)).unwrap();
            console.log('POST request successful!', result);
            alert("Sale Order Added Successfully....!!!");
            window.location.reload();
        } catch (error) {
            console.error('Error while making POST request:', error);
        } finally {
            setLoading(false);
        }

    };


    return (
        <>
            <Titlebar data={SaleOrderList} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>Sale Order Entry - Quotation No. Wise</h2>
                <Grid container>
                    <Grid item>
                        <Paper style={{ padding: '2vh', paddingLeft: '2%' }}>
                            <Grid container spacing={0.5} >

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="firm">Firm:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="firm"
                                                    options={firmlist.data}
                                                    getOptionLabel={(option) => option.firmNm || ''} // Ensure this returns the correct label
                                                    value={firmlist.data.find(firm => firm.ID === formData.firm) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'firm', value: newValue ? newValue.ID : '' } }, 'firm')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* {errors.firm && <FormHelperText style={errorStyles}>{errors.firm}</FormHelperText>} */}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="party">Party:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="party"
                                                    options={partylist?.data || []} // Use optional chaining and provide an empty array if undefined
                                                    getOptionLabel={(option) => option.partyNm || ''} // Ensure this returns the correct label
                                                    value={partylist?.data?.find(party => party.ID === formData.party) || null} // Check if partylist.data is defined
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'party', value: newValue ? newValue.ID : '' } }, 'party')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />

                                                {/* {errors.party && <FormHelperText style={errorStyles}>{errors.party}</FormHelperText>} */}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="quotNo">Quotation No:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth >
                                                <Autocomplete
                                                    id="quotNo"
                                                    options={
                                                        entries?.length
                                                            ? quotlist?.data?.filter((item) =>
                                                                entries.some((entry) => entry.quotId !== item.ID)
                                                            )
                                                            : quotlist?.data || []
                                                    }

                                                    getOptionLabel={(option) => `${option.quotNo}-${option.itemNm}` || ''} // Ensure this returns the correct label
                                                    value={quotlist?.data?.find(quot => quot.ID === formData.quotNo) || null} // Ensure this returns the full object
                                                    onChange={(event, newValue) => handleDropdownChange({ target: { name: 'quotNo', value: newValue ? newValue.ID : '' } }, 'quotNo')}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            variant="outlined"
                                                            placeholder='Select Option'
                                                            sx={{
                                                                ...inputStyles,
                                                                '& .MuiInputBase-root': {
                                                                    height: '35px', // Set your desired height here
                                                                },
                                                            }}
                                                        />
                                                    )}
                                                />
                                                {/* {errors.quotNo && <FormHelperText style={errorStyles}>{errors.quotNo}</FormHelperText>} */}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                {[
                                    { label: 'Order Date', name: 'ordt', type: 'date' },
                                    { label: 'SO No', name: 'sono', type: 'readOnly' },
                                    { label: 'Barcode', name: 'barcode', type: 'readOnly' },
                                    { label: 'Order No.', name: 'orderNo' },
                                    { label: 'Total Qty', name: 'totqty', type: 'readOnly' },
                                ].map((field, index) => (
                                    <Grid item xs={12} md={6} key={index}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                                <InputLabel htmlFor={field.name}>{field.label}:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    {field.type === 'date' ? (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            type="date"
                                                            value={formData[field.name]}
                                                            onChange={handleDateChange}
                                                            inputProps={{ style: styled.inputDate }}
                                                            sx={inputStyles}
                                                        />
                                                    ) : (
                                                        <TextField
                                                            id={field.name}
                                                            name={field.name}
                                                            value={formData[field.name] || ''}
                                                            onChange={handleInputChange}
                                                            inputProps={{ style: styled.input, readOnly: field.type === 'readOnly' }}
                                                            sx={inputStyles}
                                                        />
                                                    )}

                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                ))}

                                {openTable === true &&
                                    <>
                                        <Grid item xs={10} md={10}>
                                            <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle, display: 'flex' }}>
                                                <Table style={{ width: '60%' }}>
                                                    <TableHead>
                                                        <TableRow className='tbl-row'>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Particulars</TableCell>

                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            {itemData.data.length > 0 && itemData.data.map((item) => (
                                                                <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                                    {item.itemNm}<br />{item.clothNm}<br /> {item.m1cloth !== '0' && item.m1cloth}<br />
                                                                    &nbsp;{item.m2cloth !== '0' && item.m2cloth}<br /> {item.m3cloth !== '0' && item.m3cloth}</TableCell>
                                                            ))}
                                                        </TableRow>

                                                    </TableBody>
                                                </Table>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow className='tbl-row'>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                            {itemData.avgs.length > 0 ? itemData.avgs.map((item, index) => (
                                                                <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.size}</TableCell>
                                                            )) : ''}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Rate</TableCell>

                                                            {itemData.avgs ? itemData.avgs.map((item, index) => (
                                                                <TableCell key={index} sx={{ p: 1, border: '1px solid #000' }} align='center'>{item.rate}</TableCell>
                                                            )) : ''}
                                                        </TableRow>

                                                        <TableRow>
                                                            <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Qty</TableCell>

                                                            {itemData.avgs.length > 0 ? itemData.avgs.map((item, index) => (
                                                                <TableCell align='center' sx={{ p: 1, border: '1px solid #000' }} key={index}>
                                                                    <input
                                                                        type="text"
                                                                        value={formData.qty[index] || '0'}
                                                                        onChange={(e) => handleQtyChange(index, e.target.value)}
                                                                        style={{ width: '50px', padding: '1px' }}
                                                                    />
                                                                </TableCell>
                                                            )) : ''}
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </Grid>

                                        <Grid item xs={12}>
                                            <div style={{ margin: '1% 5%' }}>
                                                <Button variant="contained" color="primary" onClick={handleAddClick} disabled={formData.qty.length <= 0}>Add</Button>
                                            </div>
                                        </Grid>
                                    </>
                                }

                                <Grid item xs={12}>
                                    <Button variant="contained" color="primary" onClick={handleRemoveClick}>Remove</Button>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                    <TableContainer style={{ ...tableContainerStyle, ...webkitScrollbarStyle }}>
                                        <Table>
                                            <TableHead>
                                                <TableRow className='tbl-row'>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Remove</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Sr.No</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Quotation No.</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Particular</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Size</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Rate(Rs.)</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Quantity</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>Total Qty</TableCell>
                                                </TableRow>
                                            </TableHead>
                                            {entries?.length > 0 ? entries?.map((val, index) => (
                                                <TableBody>

                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>
                                                        <Checkbox
                                                            checked={selectedRows.has(index)}
                                                            onChange={() => handleCheckboxChange(index)}
                                                        />
                                                    </TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{index + 1}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.quotationNo}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.particular}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.size.join(',')}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.rate.join(',')}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.qty.join(',')}</TableCell>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000', fontSize: '15px' }} align='center'>{val.totqty}</TableCell>
                                                </TableBody>
                                            )) : ''}

                                        </Table>
                                    </TableContainer>
                                </Grid>


                                {entries?.length > 0 &&
                                    (<Grid item xs={12} textAlign="center">
                                        <Button variant="contained" color="primary" onClick={handleSubmit} disabled={loading === true}>
                                            {
                                                loading === true ?
                                                    <><CircularProgress size="20px" /> wait...</> :
                                                    "Submit"
                                            }
                                        </Button>
                                    </Grid>)}

                            </Grid>
                            <ToastContainer />
                        </Paper>
                    </Grid>
                </Grid>

            </div>
        </>
    );
}

export default SOqtwise;